// @flow

export const foundNewVersion = (newVersion: string) => ({
  type: 'AUTO_UPDATES',
  payload: { newVersion }
});
